export default __webpack_public_path__ + "static/media/RhymesColors_11.287899bd.png";